module.exports = __webpack_public_path__ + "img/waggle-logo.light.937c87b5.svg";